import { type RouteRecordRaw, createRouter, createWebHistory } from 'vue-router';

const routes: Array<RouteRecordRaw> = [
  { path: '/', redirect: '/certificate' },

  
  { path: '/home', name: 'Home', component: () => import('@/views/Home.vue') },

  { path: '/certificate', name: 'Certificate', component: () => import('@/views/Certificate/index.vue') },
  { path: '/create-slow', name: 'CreateSlow', component: () => import('@/views/SlowPage/index.vue') },
];

const router = createRouter({
  history: createWebHistory(),
  routes, // `routes: routes` 的缩写
});

export default router;
